import { render, staticRenderFns } from "./FacturacionInformacionInstitucion.vue?vue&type=template&id=45bb6c43"
import script from "./FacturacionInformacionInstitucion.vue?vue&type=script&lang=js"
export * from "./FacturacionInformacionInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports